(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function syncHeight(bar) {
      const section = bar.closest('.shopify-section');
      const h = section ? section.offsetHeight : bar.offsetHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }

    const bars = document.querySelectorAll('.announcement');

    if (bars.length === 0) {
      document.documentElement.style.removeProperty('--announcement-height');
      return;
    }

    bars.forEach(function (bar) {
      syncHeight(bar);
      window.addEventListener('resize', function () { syncHeight(bar); });
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(function () { syncHeight(bar); }).observe(bar);
      }

      const slides = bar.querySelectorAll('.announcement__slide');
      if (slides.length < 2) return;

      const interval = parseInt(bar.dataset.rotateMs, 10) || 4000;
      let index = 0;
      let timer = null;

      function show(next) {
        slides[index].classList.remove('is-active');
        index = (next + slides.length) % slides.length;
        slides[index].classList.add('is-active');
      }

      function start() {
        stop();
        timer = window.setInterval(function () { show(index + 1); }, interval);
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);

      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;

    var headerConfig = document.querySelector('[data-header-config]');
    var moneyFormat = headerConfig ? (headerConfig.getAttribute('data-money-format') || '') : '';

    function formatMoney(cents) {
      if (!moneyFormat) return (cents / 100).toFixed(2);
      var amount = (cents / 100).toFixed(2);
      var amountNoDecimals = Math.round(cents / 100).toString();
      var amountWithComma = amount.replace('.', ',');
      var formatted = moneyFormat
        .replace(/[{][{]amount_with_comma_separator[}][}]/, amountWithComma)
        .replace(/[{][{]amount_no_decimals[}][}]/, amountNoDecimals)
        .replace(/[{][{]amount_no_decimals_with_comma_separator[}][}]/, amountNoDecimals)
        .replace(/[{][{]amount[}][}]/, amount);
      return formatted;
    }

    function updateCart(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        /* Update subtotal */
        var subtotalEl = page.querySelector('[data-cart-subtotal]');
        if (subtotalEl) {
          subtotalEl.textContent = formatMoney(cart.total_price);
        }

        /* Update header cart count */
        var countEl = document.querySelector('.header__cart-count');
        if (countEl) {
          if (cart.item_count > 0) {
            countEl.textContent = cart.item_count;
          } else {
            countEl.remove();
          }
        }

        /* If cart is empty, reload to show empty state */
        if (cart.item_count === 0) {
          window.location.reload();
        }

        return cart;
      });
    }

    var alertsContainer = page.querySelector('[data-cart-alerts]');

    function showAlert(name, msg) {
      alertsContainer.hidden = false;
      var el = document.createElement('div');
      el.className = 'cart-page__alert';
      el.textContent = name + ' \u2014 ' + msg;
      alertsContainer.appendChild(el);
      setTimeout(function() {
        el.remove();
        if (!alertsContainer.children.length) alertsContainer.hidden = true;
      }, 4000);
    }

    page.querySelectorAll('[data-cart-item]').forEach(function(item) {
      var key = item.getAttribute('data-line-key');
      var qtyInput = item.querySelector('[data-cart-qty]');
      var minusBtn = item.querySelector('[data-cart-minus]');
      var plusBtn = item.querySelector('[data-cart-plus]');
      var removeBtn = item.querySelector('[data-cart-remove]');
      var totalEl = item.querySelector('[data-cart-line-total]');
      var maxQty = parseInt(item.getAttribute('data-inventory-quantity'), 10);
      var policy = item.getAttribute('data-inventory-policy');
      var hasLimit = policy === 'deny' && !isNaN(maxQty);
      var productName = (item.querySelector('.cart-page__item-title') || {}).textContent || '';

      function checkPlusBtn(qty) {
        if (plusBtn) plusBtn.disabled = hasLimit && qty >= maxQty;
      }
      checkPlusBtn(parseInt(qtyInput.value, 10) || 1);

      function updateLine(newQty) {
        if (newQty < 0) newQty = 0;

        if (hasLimit && newQty > maxQty) {
          showAlert(productName, 'Only ' + maxQty + ' available');
          qtyInput.value = maxQty;
          checkPlusBtn(maxQty);
          return;
        }

        qtyInput.value = newQty;
        if (newQty === 0) item.style.opacity = '0.5';

        updateCart(key, newQty).then(function(cart) {
          if (newQty === 0) { item.remove(); return; }

          var lineItem = cart.items.find(function(i) { return i.key === key; });
          if (lineItem) {
            if (totalEl) totalEl.textContent = '$' + (lineItem.line_price / 100).toFixed(2);
            qtyInput.value = lineItem.quantity;

            if (lineItem.quantity < newQty) {
              hasLimit = true;
              maxQty = lineItem.quantity;
              showAlert(productName, 'Only ' + lineItem.quantity + ' available');
              checkPlusBtn(lineItem.quantity);
            } else {
              checkPlusBtn(newQty);
            }
          }
        });
      }

      if (minusBtn) minusBtn.addEventListener('click', function() {
        updateLine((parseInt(qtyInput.value, 10) || 1) - 1);
      });
      if (plusBtn) plusBtn.addEventListener('click', function() {
        updateLine((parseInt(qtyInput.value, 10) || 1) + 1);
      });
      if (removeBtn) removeBtn.addEventListener('click', function() { updateLine(0); });

      if (qtyInput) qtyInput.addEventListener('change', function() {
        var val = parseInt(this.value, 10);
        if (isNaN(val) || val < 0) val = 0;
        updateLine(val);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-row"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-collection-row]').forEach(function(row) {
      var slider = row.querySelector('[data-row-slider]');
      var track = row.querySelector('[data-row-track]');
      var prevBtn = row.querySelector('[data-row-prev]');
      var nextBtn = row.querySelector('[data-row-next]');

      if (!slider || !track || !prevBtn || !nextBtn) return;

      var position = 0;

      function getItemsPerView() {
        var w = window.innerWidth;
        if (w >= 1400) return 6;
        if (w >= 1200) return 5;
        if (w >= 990) return 5;
        if (w >= 850) return 4;
        if (w >= 550) return 3;
        return 2;
      }

      function getItemWidth() {
        var item = track.querySelector('.collection-row__item');
        if (!item) return 0;
        var style = getComputedStyle(track);
        var gap = parseFloat(style.gap) || 16;
        return item.offsetWidth + gap;
      }

      function totalItems() {
        return track.querySelectorAll('.collection-row__item').length;
      }

      function maxPosition() {
        var perView = getItemsPerView();
        var total = totalItems();
        return Math.max(0, total - perView);
      }

      function updateButtons() {
        prevBtn.disabled = position <= 0;
        nextBtn.disabled = position >= maxPosition();
      }

      function slide() {
        var itemWidth = getItemWidth();
        track.style.transform = 'translateX(-' + (position * itemWidth) + 'px)';
        updateButtons();
      }

      prevBtn.addEventListener('click', function() {
        position = Math.max(0, position - getItemsPerView());
        slide();
      });

      nextBtn.addEventListener('click', function() {
        position = Math.min(maxPosition(), position + getItemsPerView());
        slide();
      });

      /* Touch swipe */
      var startX = 0;
      var isDragging = false;

      slider.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        isDragging = true;
      }, { passive: true });

      slider.addEventListener('touchend', function(e) {
        if (!isDragging) return;
        isDragging = false;
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) {
            position = Math.min(maxPosition(), position + 1);
          } else {
            position = Math.max(0, position - 1);
          }
          slide();
        }
      });

      /* Reset on resize */
      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          position = Math.min(position, maxPosition());
          slide();
        }, 150);
      });

      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-collection-section]');
    if (!section) return;

    var productGrid = section.querySelector('[data-product-grid]');
    var productList = section.querySelector('[data-product-list]');
    var wrapper = section.querySelector('[data-load-more-wrapper]');
    var btn = section.querySelector('[data-load-more]');
    var countEl = section.querySelector('[data-load-more-count]');
    var total = wrapper ? parseInt(wrapper.getAttribute('data-total-products'), 10) : 0;
    var nextUrl = wrapper ? wrapper.getAttribute('data-next-url') : '';
    var isLoading = false;

    var perPageLimit = 0;

    function allGridItems() {
      return productGrid ? productGrid.querySelectorAll('.collection__item') : [];
    }

    function allListItems() {
      return productList ? productList.querySelectorAll('.collection__list-item') : [];
    }

    function visibleCount() {
      var items = allGridItems();
      var count = 0;
      items.forEach(function(el) { if (!el.hidden) count++; });
      return count;
    }

    function totalLoaded() {
      return allGridItems().length;
    }

    function applyLimit(limit) {
      perPageLimit = limit;
      allGridItems().forEach(function(el, i) { el.hidden = i >= limit; });
      allListItems().forEach(function(el, i) { el.hidden = i >= limit; });
    }

    function refreshUI() {
      var showing = perPageLimit ? Math.min(perPageLimit, totalLoaded()) : totalLoaded();
      if (countEl) {
        countEl.textContent = showing + ' of ' + total + ' products';
      }
      if (btn) {
        /* Show load-more if there are hidden items to reveal OR more pages to fetch */
        var hasHidden = perPageLimit && totalLoaded() > perPageLimit;
        btn.hidden = !nextUrl && !hasHidden;
        btn.disabled = false;
        var text = btn.querySelector('[data-load-more-text]');
        var spinner = btn.querySelector('[data-load-more-spinner]');
        if (text) text.hidden = false;
        if (spinner) spinner.hidden = true;
      }
      isLoading = false;
    }

    function showSpinner() {
      if (!btn) return;
      btn.hidden = false;
      btn.disabled = true;
      var text = btn.querySelector('[data-load-more-text]');
      var spinner = btn.querySelector('[data-load-more-spinner]');
      if (text) text.hidden = true;
      if (spinner) spinner.hidden = false;
      isLoading = true;
    }

    function fetchNext() {
      if (!nextUrl || !productGrid) return Promise.resolve();

      return fetch(nextUrl)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          doc.querySelectorAll('[data-product-grid] .collection__item').forEach(function(el) {
            productGrid.appendChild(el);
          });

          if (productList) {
            doc.querySelectorAll('[data-product-list] .collection__list-item').forEach(function(el) {
              productList.appendChild(el);
            });
          }

          /* Read the next-url from the fetched page's wrapper */
          var fetchedWrapper = doc.querySelector('[data-load-more-wrapper]');
          nextUrl = fetchedWrapper ? fetchedWrapper.getAttribute('data-next-url') : '';
        });
    }

    function prefetchAllRemainingPages() {
      if (!productGrid || !wrapper || !nextUrl) return Promise.resolve();
      var totalPages = parseInt(wrapper.getAttribute('data-total-pages'), 10) || 1;

      function buildPageUrl(pageNum) {
        return nextUrl.replace(/([?&])page=\d+/, '$1page=' + pageNum);
      }

      function fetchPage(pageNum) {
        return fetch(buildPageUrl(pageNum))
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var gridItems = [];
            var listItems = [];
            doc.querySelectorAll('[data-product-grid] .collection__item').forEach(function(el) {
              gridItems.push(el);
            });
            doc.querySelectorAll('[data-product-list] .collection__list-item').forEach(function(el) {
              listItems.push(el);
            });
            return { page: pageNum, gridItems: gridItems, listItems: listItems };
          })
          .catch(function() {
            return { page: pageNum, gridItems: [], listItems: [], error: true };
          });
      }

      /* Determine the first page we still need. The next URL tells us
         the next page number; fetch from there to the last page. */
      var nextPageMatch = nextUrl.match(/[?&]page=(\d+)/);
      var startPage = nextPageMatch ? parseInt(nextPageMatch[1], 10) : 2;
      var pageNums = [];
      for (var i = startPage; i <= totalPages; i++) {
        pageNums.push(i);
      }

      if (pageNums.length === 0) return Promise.resolve();

      return Promise.all(pageNums.map(fetchPage)).then(function(results) {
        results.sort(function(a, b) { return a.page - b.page; });
        results.forEach(function(r) {
          r.gridItems.forEach(function(el) { productGrid.appendChild(el); });
          if (productList) {
            r.listItems.forEach(function(el) { productList.appendChild(el); });
          }
        });
        nextUrl = '';
      });
    }

    function showUntil(target) {
      /* If we already have enough items loaded, just show/hide */
      if (totalLoaded() >= target) {
        applyLimit(target);
        refreshUI();
        return;
      }

      /* Need to fetch more */
      if (!nextUrl) {
        applyLimit(target);
        refreshUI();
        return;
      }

      showSpinner();

      fetchNext()
        .then(function() {
          if (totalLoaded() < target && nextUrl) {
            showUntil(target);
          } else {
            applyLimit(target);
            refreshUI();
          }
        })
        .catch(function() {
          applyLimit(target);
          refreshUI();
        });
    }

    /* Sort by */
    var sortSelect = section.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    /* Per page */
    section.querySelectorAll('[data-per-page]').forEach(function(button) {
      button.addEventListener('click', function() {
        if (isLoading) return;
        var target = parseInt(this.getAttribute('data-per-page'), 10);

        section.querySelectorAll('[data-per-page]').forEach(function(b) {
          b.classList.remove('collection__per-page-button--active');
          b.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('collection__per-page-button--active');
        this.setAttribute('aria-pressed', 'true');

        showUntil(target);
      });
    });

    /* View toggle */
    var gridView = section.querySelector('[data-view-target="grid"]');
    var listView = section.querySelector('[data-view-target="list"]');

    if (gridView && listView) {
      section.querySelectorAll('[data-view]').forEach(function(button) {
        button.addEventListener('click', function() {
          var view = this.getAttribute('data-view');

          section.querySelectorAll('[data-view]').forEach(function(b) {
            b.classList.remove('collection__view-button--active');
            b.setAttribute('aria-pressed', 'false');
          });
          this.classList.add('collection__view-button--active');
          this.setAttribute('aria-pressed', 'true');

          gridView.hidden = view === 'list';
          listView.hidden = view === 'grid';
        });
      });
    }

    /* Key issue filter — applies across all pages, not just the current view */
    var keyIssueToggle = document.querySelector('[data-key-issue-filter]');
    var defaultPerPage = 24;
    var firstPerPageBtn = section.querySelector('[data-per-page]');
    if (firstPerPageBtn) {
      defaultPerPage = parseInt(firstPerPageBtn.getAttribute('data-per-page'), 10) || 24;
    }

    function applyKeyIssueFilter(filterOn) {
      if (filterOn) {
        var keyCount = 0;
        allGridItems().forEach(function(item) {
          var isKey = !!item.querySelector('[data-key-issue]');
          if (isKey) keyCount++;
          item.style.display = isKey ? '' : 'none';
          item.hidden = false;
        });
        allListItems().forEach(function(item) {
          var isKey = !!item.querySelector('[data-key-issue]');
          item.style.display = isKey ? '' : 'none';
          item.hidden = false;
        });
        if (countEl) {
          countEl.textContent = keyCount + ' key ' + (keyCount === 1 ? 'issue' : 'issues') + ' of ' + total + ' products';
        }
        if (btn) btn.hidden = true;
        isLoading = false;
      } else {
        allGridItems().forEach(function(item) { item.style.display = ''; });
        allListItems().forEach(function(item) { item.style.display = ''; });
        applyLimit(perPageLimit || defaultPerPage);
        refreshUI();
      }
    }

    if (keyIssueToggle) {
      keyIssueToggle.addEventListener('change', function() {
        var filterOn = this.checked;
        keyIssueToggle.disabled = true;

        var work = (filterOn && nextUrl) ? prefetchAllRemainingPages() : Promise.resolve();

        work.then(function() {
          applyKeyIssueFilter(filterOn);
          keyIssueToggle.disabled = false;
        }).catch(function() {
          keyIssueToggle.disabled = false;
        });
      });
    }

    function scrollToItem(index) {
      var items = (listView && !listView.hidden) ? allListItems() : allGridItems();
      var target = items[index];
      if (!target) return;
      var headerOffset = 140;
      var top = target.getBoundingClientRect().top + window.scrollY - headerOffset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    /* Load more button */
    if (btn) {
      btn.addEventListener('click', function() {
        if (isLoading) return;

        /* If there are hidden items we can reveal, show the next batch */
        if (perPageLimit && totalLoaded() > visibleCount()) {
          var firstHiddenIndex = visibleCount();
          var newLimit = perPageLimit + parseInt(section.querySelectorAll('[data-per-page]')[0].getAttribute('data-per-page'), 10);
          applyLimit(newLimit);
          refreshUI();
          scrollToItem(firstHiddenIndex);
          return;
        }

        /* Otherwise fetch next page from server */
        if (!nextUrl) return;
        var firstNewIndex = totalLoaded();
        showSpinner();
        fetchNext()
          .then(function() {
            if (perPageLimit) applyLimit(perPageLimit);
            refreshUI();
            scrollToItem(firstNewIndex);
          })
          .catch(refreshUI);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    document.addEventListener('cart:item-added', function() {
      var cartBtn = document.querySelector('.header__cart');
      if (!cartBtn) return;
      cartBtn.classList.remove('header__cart--bumped');
      void cartBtn.offsetWidth;
      cartBtn.classList.add('header__cart--bumped');
      var plus = cartBtn.querySelector('.header__cart-plus');
      if (plus) plus.remove();
      plus = document.createElement('span');
      plus.className = 'header__cart-plus';
      plus.textContent = '+1';
      plus.setAttribute('aria-hidden', 'true');
      cartBtn.appendChild(plus);
      window.setTimeout(function() {
        cartBtn.classList.remove('header__cart--bumped');
        if (plus && plus.parentNode) plus.parentNode.removeChild(plus);
      }, 900);
    });
  })();

  (function() {
    var configEl = document.querySelector('[data-header-config]');
    function attr(name) { return configEl ? configEl.getAttribute('data-' + name) || '' : ''; }
    var moneyFormat = attr('money-format');
    var strings = {
      noResults: attr('no-results'),
      searching: attr('searching'),
      searchError: attr('search-error'),
      typeArticle: attr('type-article'),
      typePage: attr('type-page'),
      typeCollection: attr('type-collection'),
      typeCollections: attr('type-collections'),
      typeProducts: attr('type-products'),
      each: attr('each'),
      onlyXAvailable: attr('only-available'),
      removeLabel: attr('remove-label')
    };

    function formatMoney(cents) {
      if (!moneyFormat) return (cents / 100).toFixed(2);
      var amount = (cents / 100).toFixed(2);
      var amountNoDecimals = Math.round(cents / 100).toString();
      var amountWithComma = amount.replace('.', ',');
      return moneyFormat
        .replace(new RegExp('[{][{]amount_with_comma_separator[}][}]'), amountWithComma)
        .replace(new RegExp('[{][{]amount_no_decimals[}][}]'), amountNoDecimals)
        .replace(new RegExp('[{][{]amount_no_decimals_with_comma_separator[}][}]'), amountNoDecimals)
        .replace(new RegExp('[{][{]amount[}][}]'), amount);
    }

    function initDrawer(el, openClass, closeSel, onOpen, onClose) {
      function open() {
        el.hidden = false;
        requestAnimationFrame(function() { el.classList.add(openClass); });
        document.body.style.overflow = 'hidden';
        if (onOpen) onOpen();
      }
      function close() {
        el.classList.remove(openClass);
        document.body.style.overflow = '';
        if (onClose) onClose();
        var bodyEl = el.querySelector('[class$="__body"]');
        (bodyEl || el).addEventListener('transitionend', function handler(e) {
          if (e.target !== (bodyEl || el)) return;
          if (!el.classList.contains(openClass)) el.hidden = true;
          (bodyEl || el).removeEventListener('transitionend', handler);
        });
      }
      el.querySelectorAll(closeSel).forEach(function(btn) {
        btn.addEventListener('click', close);
      });
      return { open: open, close: close };
    }

    /* Desktop mega nav hover */
    document.querySelectorAll('.mega-nav__item--has-children').forEach(function(item) {
      var categories = item.querySelectorAll('[data-mega-category]');
      var contents = item.querySelectorAll('[data-mega-content]');
      if (categories.length === 0 || contents.length === 0) return;

      categories.forEach(function(cat) {
        cat.addEventListener('mouseenter', function() {
          categories.forEach(function(c) { c.classList.remove('mega-nav__category--active'); });
          contents.forEach(function(c) { c.classList.remove('mega-nav__subcontent--active'); });
          cat.classList.add('mega-nav__category--active');

          var handle = cat.getAttribute('data-mega-handle') || '';
          if (!handle) return;
          var target = item.querySelector('[data-mega-content="' + handle + '"]');
          if (target) target.classList.add('mega-nav__subcontent--active');
        });
      });
    });

    /* Mobile drawer */
    var drawer = document.getElementById('mobile-drawer');
    var toggleBtn = document.querySelector('[data-drawer-toggle]');

    if (drawer) {
      var mobileDrawer = initDrawer(drawer, 'mobile-drawer--open', '[data-drawer-close]',
        function() { if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true'); },
        function() { if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false'); }
      );

      if (toggleBtn) toggleBtn.addEventListener('click', mobileDrawer.open);

      drawer.querySelectorAll('[data-mobile-expand]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var expanded = this.getAttribute('aria-expanded') === 'true';
          var sub = this.closest('.mobile-nav__item').querySelector(':scope > .mobile-nav__sub');
          if (!sub) return;
          this.setAttribute('aria-expanded', !expanded);
          sub.hidden = expanded;
        });
      });
    }

    /* Cart drawer */
    var cartDrawer = document.getElementById('cart-drawer');
    var cartToggle = document.querySelector('[data-cart-toggle]');

    if (cartDrawer && cartToggle) {
      var sectionId = attr('section-id');

      function availableMsg(qty) {
        if (strings.onlyXAvailable) return strings.onlyXAvailable.replace(new RegExp('[{][{]\\s*count\\s*[}][}]'), qty);
        return 'Only ' + qty + ' available';
      }

      function showDrawerWarning(itemEl, msg) {
        var existing = itemEl.querySelector('.cart-drawer__item-warning');
        if (existing) existing.remove();
        var warning = document.createElement('p');
        warning.className = 'cart-drawer__item-warning';
        warning.textContent = msg;
        itemEl.querySelector('.cart-drawer__item-info').appendChild(warning);
        setTimeout(function() { warning.remove(); }, 3000);
      }

      function updateHeaderCount(count) {
        var headerCount = document.querySelector('.header__cart-count');
        if (headerCount) {
          if (count > 0) { headerCount.textContent = count; }
          else { headerCount.remove(); }
        } else if (count > 0) {
          var cartBtn = document.querySelector('[data-cart-toggle]');
          if (cartBtn) {
            var span = document.createElement('span');
            span.className = 'header__cart-count';
            span.textContent = count;
            cartBtn.appendChild(span);
          }
        }
      }

      function updateDrawerMeta(cart) {
        var subtotalEl = cartDrawer.querySelector('[data-cart-drawer-subtotal]');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        var countEl = cartDrawer.querySelector('[data-cart-drawer-count]');
        if (countEl) countEl.textContent = cart.item_count;
        updateHeaderCount(cart.item_count);
        var emptyEl = cartDrawer.querySelector('[data-cart-drawer-empty]');
        var footerEl = cartDrawer.querySelector('[data-cart-drawer-footer]');
        if (emptyEl) emptyEl.hidden = cart.item_count > 0;
        if (footerEl) footerEl.hidden = cart.item_count === 0;
      }

      function changeCartItem(key, quantity) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        })
        .then(function(r) { return r.json(); });
      }

      function bindCartItems() {
        cartDrawer.querySelectorAll('[data-cart-drawer-item]').forEach(function(item) {
          var key = item.getAttribute('data-line-key');
          var qtyValue = item.querySelector('[data-drawer-qty-value]');
          var minusBtn = item.querySelector('[data-drawer-qty-minus]');
          var plusBtn = item.querySelector('[data-drawer-qty-plus]');
          var removeBtn = item.querySelector('[data-drawer-remove]');
          var maxQty = parseInt(item.getAttribute('data-inventory-quantity'), 10);
          var policy = item.getAttribute('data-inventory-policy');
          var hasLimit = policy === 'deny' && !isNaN(maxQty);

          function checkPlusBtn(currentQty) {
            if (!plusBtn) return;
            plusBtn.disabled = hasLimit && currentQty >= maxQty;
          }

          checkPlusBtn(parseInt(qtyValue.textContent, 10) || 1);

          function updateQty(newQty) {
            if (newQty < 0) newQty = 0;

            if (hasLimit && newQty > maxQty) {
              showDrawerWarning(item, availableMsg(maxQty));
              checkPlusBtn(maxQty);
              return;
            }

            if (qtyValue) qtyValue.textContent = newQty;
            if (newQty === 0) item.style.opacity = '0.5';

            changeCartItem(key, newQty).then(function(cart) {
              updateDrawerMeta(cart);

              if (newQty === 0) { item.remove(); return; }

              var lineItem = cart.items.find(function(i) { return i.key === key; });
              if (lineItem && lineItem.quantity < newQty) {
                hasLimit = true;
                maxQty = lineItem.quantity;
                qtyValue.textContent = lineItem.quantity;
                showDrawerWarning(item, availableMsg(lineItem.quantity));
                checkPlusBtn(lineItem.quantity);
              } else {
                checkPlusBtn(newQty);
              }

              var lineTotalEl = item.querySelector('[data-drawer-line-total]');
              if (lineTotalEl && lineItem) lineTotalEl.textContent = formatMoney(lineItem.line_price);

              var unitPriceEl = item.querySelector('.cart-drawer__item-unit-price');
              if (lineItem && lineItem.quantity > 1) {
                var unitText = formatMoney(lineItem.price) + ' ' + (strings.each || 'each');
                if (unitPriceEl) { unitPriceEl.textContent = unitText; }
                else {
                  var priceRow = item.querySelector('.cart-drawer__item-price-row');
                  if (priceRow) {
                    var u = document.createElement('span');
                    u.className = 'cart-drawer__item-unit-price';
                    u.textContent = unitText;
                    priceRow.appendChild(u);
                  }
                }
              } else if (unitPriceEl) {
                unitPriceEl.remove();
              }
            });
          }

          if (minusBtn) minusBtn.addEventListener('click', function() {
            updateQty((parseInt(qtyValue.textContent, 10) || 1) - 1);
          });
          if (plusBtn) plusBtn.addEventListener('click', function() {
            updateQty((parseInt(qtyValue.textContent, 10) || 1) + 1);
          });
          if (removeBtn) removeBtn.addEventListener('click', function() { updateQty(0); });
        });
      }

      function refreshDrawer() {
        return fetch('/?section_id=' + sectionId)
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var temp = document.createElement('div');
            temp.innerHTML = html;

            var freshItems = temp.querySelector('[data-cart-drawer-items]');
            var currentItems = cartDrawer.querySelector('[data-cart-drawer-items]');
            if (freshItems && currentItems) currentItems.innerHTML = freshItems.innerHTML;

            var freshCount = temp.querySelector('[data-cart-drawer-count]');
            var currentCount = cartDrawer.querySelector('[data-cart-drawer-count]');
            if (freshCount && currentCount) currentCount.textContent = freshCount.textContent;

            var freshSubtotal = temp.querySelector('[data-cart-drawer-subtotal]');
            var currentSubtotal = cartDrawer.querySelector('[data-cart-drawer-subtotal]');
            if (freshSubtotal && currentSubtotal) currentSubtotal.textContent = freshSubtotal.textContent;

            var freshEmpty = temp.querySelector('[data-cart-drawer-empty]');
            var currentEmpty = cartDrawer.querySelector('[data-cart-drawer-empty]');
            if (freshEmpty && currentEmpty) currentEmpty.hidden = freshEmpty.hidden;

            var freshSummary = temp.querySelector('[data-cart-drawer-summary]');
            var currentSummary = cartDrawer.querySelector('[data-cart-drawer-summary]');
            if (freshSummary && currentSummary) currentSummary.hidden = freshSummary.hidden;

            var checkoutBtn = cartDrawer.querySelector('[data-cart-drawer-checkout]');
            var viewCartBtn = cartDrawer.querySelector('[data-cart-drawer-view-cart]');
            var isEmpty = (parseInt((temp.querySelector('[data-cart-drawer-count]') || {}).textContent, 10) || 0) === 0;
            [checkoutBtn, viewCartBtn].forEach(function(btn) {
              if (!btn) return;
              btn.classList.toggle(btn.classList.contains('cart-drawer__checkout') ? 'cart-drawer__checkout--disabled' : 'cart-drawer__view-cart--disabled', isEmpty);
              if (isEmpty) {
                btn.setAttribute('aria-disabled', 'true');
                btn.setAttribute('tabindex', '-1');
              } else {
                btn.removeAttribute('aria-disabled');
                btn.removeAttribute('tabindex');
              }
            });

            var freshHeaderCount = temp.querySelector('.header__cart-count');
            if (freshHeaderCount) {
              updateHeaderCount(parseInt(freshHeaderCount.textContent, 10) || 0);
            }

            bindCartItems();
          });
      }

      function openDrawer() {
        cartDrawerCtrl.open();
      }

      var cartDrawerCtrl = initDrawer(cartDrawer, 'cart-drawer--open', '[data-cart-drawer-close]');
      cartToggle.addEventListener('click', openDrawer);
      bindCartItems();
      window.openCartDrawer = openDrawer;
      window.refreshCartDrawer = refreshDrawer;
      document.addEventListener('cart:item-added', function() { refreshDrawer(); });

      var clearBtn = cartDrawer.querySelector('[data-cart-drawer-clear]');
      if (clearBtn) {
        clearBtn.addEventListener('click', function() {
          if (clearBtn.dataset.busy === '1') return;
          clearBtn.dataset.busy = '1';
          fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
            .then(function(r) { return r.json(); })
            .then(function() { window.location.reload(); })
            .catch(function() { clearBtn.dataset.busy = ''; });
        });
      }
    }

    /* Instant search */
    var searchContainer = document.querySelector('[data-instant-search]');
    if (searchContainer) {
      var input = searchContainer.querySelector('[data-instant-search-input]');
      var resultsEl = searchContainer.querySelector('[data-instant-search-results]');
      var body = searchContainer.querySelector('[data-instant-search-body]');
      var viewAll = searchContainer.querySelector('[data-instant-search-view-all]');
      var searchType = searchContainer.querySelector('input[name="type"]');
      var typeParam = searchType ? searchType.value : 'product';
      var debounceTimer = null;
      var activeIndex = -1;

      function showResults() { resultsEl.hidden = false; }
      function hideResults() { resultsEl.hidden = true; activeIndex = -1; }

      function createSearchItem(entry) {
        var r = entry.item;
        var link = document.createElement('a');
        link.href = r.url;
        link.className = 'instant-search__item';

        var imgWrap = document.createElement('div');
        imgWrap.className = 'instant-search__item-image';
        var imgSrc = (r.featured_image && r.featured_image.url) || r.image || '';
        if (imgSrc) {
          var img = document.createElement('img');
          img.src = imgSrc;
          img.alt = '';
          img.loading = 'lazy';
          imgWrap.appendChild(img);
        }
        link.appendChild(imgWrap);

        var info = document.createElement('div');
        info.className = 'instant-search__item-info';
        var title = document.createElement('div');
        title.className = 'instant-search__item-title';
        title.textContent = r.title;
        info.appendChild(title);

        var meta = '';
        if (entry.type === 'product' && r.vendor) meta = r.vendor;
        else if (entry.type === 'article') meta = strings.typeArticle || 'Article';
        else if (entry.type === 'page') meta = strings.typePage || 'Page';

        if (meta) {
          var metaEl = document.createElement('div');
          metaEl.className = 'instant-search__item-meta';
          metaEl.textContent = meta;
          info.appendChild(metaEl);
        }
        link.appendChild(info);

        var priceStr = r.price_min || r.price || '';
        if (entry.type === 'product' && priceStr) {
          var priceEl = document.createElement('span');
          priceEl.className = 'instant-search__item-price';
          priceEl.textContent = formatMoney(Math.round(parseFloat(priceStr) * 100));
          link.appendChild(priceEl);
        }

        return link;
      }

      function createCollectionItem(c) {
        var link = document.createElement('a');
        link.href = c.url;
        link.className = 'instant-search__item instant-search__item--collection';

        var imgWrap = document.createElement('div');
        imgWrap.className = 'instant-search__item-image';
        var imgSrc = (c.featured_image && c.featured_image.url) || c.image || '';
        if (imgSrc) {
          var img = document.createElement('img');
          img.src = imgSrc;
          img.alt = '';
          img.loading = 'lazy';
          imgWrap.appendChild(img);
        }
        link.appendChild(imgWrap);

        var info = document.createElement('div');
        info.className = 'instant-search__item-info';
        var title = document.createElement('div');
        title.className = 'instant-search__item-title';
        title.textContent = c.title;
        info.appendChild(title);
        var meta = document.createElement('div');
        meta.className = 'instant-search__item-meta';
        meta.textContent = strings.typeCollection || 'Collection';
        info.appendChild(meta);
        link.appendChild(info);

        return link;
      }

      function renderResults(data) {
        var res = data.resources && data.resources.results ? data.resources.results : {};
        var collections = (res.collections || []).slice(0, 3);
        var all = [].concat(
          (res.products || []).map(function(p) { return { type: 'product', item: p }; }),
          (res.articles || []).map(function(a) { return { type: 'article', item: a }; }),
          (res.pages || []).map(function(p) { return { type: 'page', item: p }; })
        );

        body.textContent = '';

        if (collections.length === 0 && all.length === 0) {
          var empty = document.createElement('div');
          empty.className = 'instant-search__empty';
          empty.textContent = strings.noResults || 'No results found';
          body.appendChild(empty);
          viewAll.hidden = true;
          showResults();
          return;
        }

        if (collections.length > 0) {
          var heading = document.createElement('div');
          heading.className = 'instant-search__group-title';
          heading.textContent = strings.typeCollections || 'Collections';
          body.appendChild(heading);
          collections.forEach(function(c) { body.appendChild(createCollectionItem(c)); });
        }

        if (all.length > 0) {
          if (collections.length > 0) {
            var divider = document.createElement('div');
            divider.className = 'instant-search__group-title';
            divider.textContent = strings.typeProducts || 'Products';
            body.appendChild(divider);
          }
          all.forEach(function(entry) { body.appendChild(createSearchItem(entry)); });
        }

        viewAll.hidden = false;
        viewAll.href = '/search?q=' + encodeURIComponent(input.value) + '&type=' + typeParam;
        showResults();
        activeIndex = -1;
      }

      function doSearch(query) {
        if (!query || query.length < 2) { hideResults(); return; }

        body.textContent = '';
        var loading = document.createElement('div');
        loading.className = 'instant-search__loading';
        loading.textContent = strings.searching || 'Searching...';
        body.appendChild(loading);
        viewAll.hidden = true;
        showResults();

        var searchTypes = typeParam.indexOf('collection') > -1 ? typeParam : typeParam + ',collection';
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=' + searchTypes + '&resources[limit]=6')
          .then(function(r) {
            if (!r.ok) throw new Error(r.status);
            return r.json();
          })
          .then(renderResults)
          .catch(function() {
            body.textContent = '';
            var err = document.createElement('div');
            err.className = 'instant-search__empty';
            err.textContent = strings.searchError || 'Something went wrong';
            body.appendChild(err);
            viewAll.hidden = true;
          });
      }

      input.addEventListener('input', function() {
        clearTimeout(debounceTimer);
        var q = this.value.trim();
        debounceTimer = setTimeout(function() { doSearch(q); }, 250);
      });

      input.addEventListener('focus', function() {
        if (this.value.trim().length >= 2 && body.children.length) showResults();
      });

      input.addEventListener('keydown', function(e) {
        var items = body.querySelectorAll('.instant-search__item');
        if (!items.length || resultsEl.hidden) return;

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          activeIndex = Math.min(activeIndex + 1, items.length - 1);
          items.forEach(function(el, i) { el.classList.toggle('instant-search__item--active', i === activeIndex); });
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          activeIndex = Math.max(activeIndex - 1, 0);
          items.forEach(function(el, i) { el.classList.toggle('instant-search__item--active', i === activeIndex); });
        } else if (e.key === 'Enter' && activeIndex >= 0) {
          e.preventDefault();
          items[activeIndex].click();
        } else if (e.key === 'Escape') {
          hideResults();
          input.blur();
        }
      });

      document.addEventListener('click', function(e) {
        if (!searchContainer.contains(e.target)) hideResults();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-header"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-password-entry]').forEach(function (entry) {
      const input = entry.querySelector('[data-password-input]');

      if (entry.querySelector('[data-password-errors]')) {
        entry.open = true;
      }

      entry.addEventListener('toggle', function () {
        if (entry.open && input) input.focus();
      });

      document.addEventListener('click', function (event) {
        if (entry.open && !entry.contains(event.target)) entry.open = false;
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && entry.open) {
          entry.open = false;
          const toggle = entry.querySelector('summary');
          if (toggle) toggle.focus();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    var page = document.querySelector('.product-page');
    if (!page) return;

    var heroImg = document.getElementById('product-hero-img');
    var thumbs = page.querySelectorAll('[data-thumb]');
    var variantBtns = page.querySelectorAll('[data-variant-id]');
    var priceEl = page.querySelector('[data-product-price]');
    var compareEl = page.querySelector('[data-product-compare]');
    var discountEl = page.querySelector('[data-product-discount]');
    var addBtn = page.querySelector('[data-product-add]');
    var qtyInput = page.querySelector('[data-qty-input]');
    var minusBtn = page.querySelector('[data-qty-minus]');
    var plusBtn = page.querySelector('[data-qty-plus]');

    var statusEl = page.querySelector('[data-product-status]');
    var statusConfig = { isPreorder: false, labels: {} };
    var statusConfigEl = page.querySelector('[data-product-status-config]');
    if (statusConfigEl) {
      try { statusConfig = JSON.parse(statusConfigEl.textContent); } catch (e) {}
    }

    var STATUS_ICON_LAST = '<svg class="product-page__status-icon" width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
      '<circle cx="8" cy="8" r="7" fill="currentColor"/>' +
      '<path d="M8 4v5" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/>' +
      '<circle cx="8" cy="11.5" r="0.9" fill="#fff"/>' +
      '</svg>';
    var STATUS_DOT = '<span class="product-page__status-dot"></span>';

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function infoTooltipHtml(text) {
      var t = escapeHtml(text);
      return '<span class="info-tooltip" tabindex="0" role="img" aria-label="' + t + '" data-info-tooltip>' +
        '<svg class="info-tooltip__icon" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
          '<circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.4"/>' +
          '<circle cx="8" cy="4.6" r="0.95" fill="currentColor"/>' +
          '<path d="M8 7.2v4.8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '</svg>' +
        '<span class="info-tooltip__bubble" role="tooltip">' + t + '</span>' +
      '</span>';
    }

    function updateStatus(btn) {
      if (!statusEl || statusConfig.isPreorder) return;
      var labels = statusConfig.labels || {};
      var available = btn.getAttribute('data-variant-available') === 'true';
      var management = btn.getAttribute('data-variant-inventory-management');
      var policy = btn.getAttribute('data-variant-inventory-policy');
      var qty = parseInt(btn.getAttribute('data-variant-inventory-quantity'), 10);
      var modifier = 'out';
      var html = STATUS_DOT + ' ' + escapeHtml(labels.out_of_stock || '');
      if (available) {
        if (management === 'shopify' && policy === 'continue' && qty <= 0) {
          modifier = 'backorder';
          html = STATUS_DOT + ' ' + escapeHtml(labels.back_order || '') + ' - ' + escapeHtml(labels.back_order_shipping || '') +
            ' ' + infoTooltipHtml(labels.back_order_tooltip || '');
        } else if (management === 'shopify' && qty === 1) {
          modifier = 'last';
          html = STATUS_ICON_LAST + ' ' + escapeHtml(labels.last_one || '');
        } else {
          modifier = 'in';
          html = STATUS_DOT + ' ' + escapeHtml(labels.in_stock || '');
        }
      }
      statusEl.className = 'product-page__status product-page__status--' + modifier;
      statusEl.innerHTML = html;
    }

    /* Lightbox */
    var lightbox = document.querySelector('[data-lightbox]');
    var lightboxImg = document.querySelector('[data-lightbox-img]');
    var lightboxCounter = document.querySelector('[data-lightbox-counter]');
    var lightboxIndex = 0;

    function openLightbox(index) {
      if (!lightbox || !lightboxImg) return;
      var src;
      if (thumbs.length > 0) {
        lightboxIndex = index;
        src = thumbs[lightboxIndex].getAttribute('data-thumb-src');
        lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + thumbs.length;
      } else if (heroImg) {
        src = heroImg.src;
        if (lightboxCounter) lightboxCounter.textContent = '1 / 1';
      }
      if (!src) return;
      lightboxImg.src = src;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function resetLightboxZoom() {
      if (!lightbox) return;
      lightbox.classList.remove('product-lightbox--zoom');
      if (lightboxImg) lightboxImg.style.transformOrigin = '';
    }

    function closeLightbox() {
      if (!lightbox) return;
      resetLightboxZoom();
      lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    function lightboxGo(dir) {
      resetLightboxZoom();
      lightboxIndex += dir;
      if (lightboxIndex < 0) lightboxIndex = thumbs.length - 1;
      if (lightboxIndex >= thumbs.length) lightboxIndex = 0;
      var src = thumbs[lightboxIndex].getAttribute('data-thumb-src');
      lightboxImg.src = src;
      if (lightboxCounter) lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + thumbs.length;
    }

    if (heroImg) {
      heroImg.addEventListener('click', function() {
        openLightbox(currentImageIndex);
      });
    }

    if (lightbox) {
      lightbox.querySelectorAll('[data-lightbox-close]').forEach(function(el) {
        el.addEventListener('click', closeLightbox);
      });

      var lbPrev = lightbox.querySelector('[data-lightbox-prev]');
      var lbNext = lightbox.querySelector('[data-lightbox-next]');
      if (lbPrev) lbPrev.addEventListener('click', function(e) { e.stopPropagation(); lightboxGo(-1); });
      if (lbNext) lbNext.addEventListener('click', function(e) { e.stopPropagation(); lightboxGo(1); });

      document.addEventListener('keydown', function(e) {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') lightboxGo(-1);
        if (e.key === 'ArrowRight') lightboxGo(1);
      });

      /* Click to zoom inside lightbox, cursor pans while zoomed */
      if (lightboxImg) {
        function setLightboxZoomOrigin(e) {
          var rect = lightboxImg.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) * 100;
          var y = ((e.clientY - rect.top) / rect.height) * 100;
          if (x < 0) x = 0; else if (x > 100) x = 100;
          if (y < 0) y = 0; else if (y > 100) y = 100;
          lightboxImg.style.transformOrigin = x + '% ' + y + '%';
        }
        lightboxImg.addEventListener('click', function(e) {
          e.stopPropagation();
          if (lightbox.classList.contains('product-lightbox--zoom')) {
            resetLightboxZoom();
          } else {
            setLightboxZoomOrigin(e);
            lightbox.classList.add('product-lightbox--zoom');
          }
        });
        lightboxImg.addEventListener('mousemove', function(e) {
          if (!lightbox.classList.contains('product-lightbox--zoom')) return;
          setLightboxZoomOrigin(e);
        });
      }
    }

    /* Hero arrows */
    var heroPrev = page.querySelector('[data-hero-prev]');
    var heroNext = page.querySelector('[data-hero-next]');
    var currentImageIndex = 0;

    function goToImage(index) {
      if (thumbs.length === 0) return;
      if (index < 0) index = thumbs.length - 1;
      if (index >= thumbs.length) index = 0;
      currentImageIndex = index;
      var thumb = thumbs[currentImageIndex];
      var newSrc = thumb.getAttribute('data-thumb-src');
      if (heroImg) {
        heroImg.removeAttribute('srcset');
        heroImg.src = newSrc;
      }
      thumbs.forEach(function(t) { t.classList.remove('product-page__thumb--active'); });
      thumb.classList.add('product-page__thumb--active');
      if (typeof thumb.scrollIntoView === 'function') {
        thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }

    if (heroPrev) {
      heroPrev.addEventListener('click', function() { goToImage(currentImageIndex - 1); });
    }
    if (heroNext) {
      heroNext.addEventListener('click', function() { goToImage(currentImageIndex + 1); });
    }

    /* Thumbnail clicks */
    thumbs.forEach(function(thumb, index) {
      thumb.addEventListener('click', function() {
        currentImageIndex = index;
        if (!heroImg) return;
        var newSrc = this.getAttribute('data-thumb-src');
        heroImg.removeAttribute('srcset');
        heroImg.src = newSrc;
        thumbs.forEach(function(t) { t.classList.remove('product-page__thumb--active'); });
        this.classList.add('product-page__thumb--active');
      });
    });

    /* Thumb carousel - sync max-height to hero, scroll buttons, overflow detection */
    var thumbsStrip = page.querySelector('[data-thumbs]');
    var thumbsCarousel = page.querySelector('[data-thumbs-carousel]');
    var thumbsPrev = page.querySelector('[data-thumbs-prev]');
    var thumbsNext = page.querySelector('[data-thumbs-next]');
    var hero = page.querySelector('[data-product-hero]');

    if (thumbsStrip && thumbsCarousel && hero) {
      function isVertical() {
        return window.matchMedia('(min-width: 750px)').matches;
      }

      function syncHeroHeight() {
        var h = hero.getBoundingClientRect().height;
        if (h > 0) thumbsCarousel.style.setProperty('--hero-h', h + 'px');
      }

      function thumbStep() {
        var first = thumbsStrip.querySelector('[data-thumb]');
        if (!first) return 80;
        var rect = first.getBoundingClientRect();
        var gap = 8;
        return (isVertical() ? rect.height : rect.width) + gap;
      }

      function updateArrowState() {
        if (!thumbsPrev || !thumbsNext) return;
        var vertical = isVertical();
        var scrollPos = vertical ? thumbsStrip.scrollTop : thumbsStrip.scrollLeft;
        var maxScroll = vertical
          ? thumbsStrip.scrollHeight - thumbsStrip.clientHeight
          : thumbsStrip.scrollWidth - thumbsStrip.clientWidth;
        var hasOverflow = maxScroll > 1;

        thumbsPrev.hidden = !hasOverflow;
        thumbsNext.hidden = !hasOverflow;

        if (hasOverflow) {
          thumbsPrev.disabled = scrollPos <= 1;
          thumbsNext.disabled = scrollPos >= maxScroll - 1;
        }
      }

      function scrollThumbs(dir) {
        var step = thumbStep() * 2;
        var opts = isVertical() ? { top: dir * step, behavior: 'smooth' } : { left: dir * step, behavior: 'smooth' };
        thumbsStrip.scrollBy(opts);
      }

      if (thumbsPrev) thumbsPrev.addEventListener('click', function() { scrollThumbs(-1); });
      if (thumbsNext) thumbsNext.addEventListener('click', function() { scrollThumbs(1); });

      thumbsStrip.addEventListener('scroll', updateArrowState, { passive: true });

      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function() {
          syncHeroHeight();
          updateArrowState();
        });
        ro.observe(hero);
        ro.observe(thumbsStrip);
      } else {
        window.addEventListener('resize', function() {
          syncHeroHeight();
          updateArrowState();
        });
      }

      window.addEventListener('load', function() {
        syncHeroHeight();
        updateArrowState();
      });

      syncHeroHeight();
      updateArrowState();
    }

    /* Variant selection */
    page.querySelectorAll('.product-page__variant-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var id = this.getAttribute('data-variant-id');
        var price = this.getAttribute('data-variant-price');
        var compare = this.getAttribute('data-variant-compare');
        var available = this.getAttribute('data-variant-available') === 'true';
        var imageSrc = this.getAttribute('data-variant-image');
        var sku = this.getAttribute('data-variant-sku');
        var barcode = this.getAttribute('data-variant-barcode');

        /* SKU & barcode */
        var skuEl = page.querySelector('[data-product-sku]');
        var barcodeEl = page.querySelector('[data-product-barcode]');
        if (skuEl) skuEl.textContent = sku || '';
        if (barcodeEl) barcodeEl.textContent = barcode || '';

        /* Details tab */
        var detailSku = page.querySelector('[data-detail-sku]');
        var detailBarcode = page.querySelector('[data-detail-barcode]');
        if (detailSku) detailSku.textContent = sku || '';
        if (detailBarcode) detailBarcode.textContent = barcode || '';

        /* Active state */
        page.querySelectorAll('.product-page__variant-btn').forEach(function(b) {
          b.classList.remove('product-page__variant-btn--active');
        });
        this.classList.add('product-page__variant-btn--active');

        /* Stock status */
        updateStatus(this);

        /* Price */
        if (priceEl) priceEl.textContent = price;

        /* Compare price */
        if (compare && compare !== price) {
          if (!compareEl) {
            var span = document.createElement('span');
            span.className = 'product-page__compare';
            span.setAttribute('data-product-compare', '');
            priceEl.parentNode.appendChild(span);
            compareEl = span;
          }
          compareEl.textContent = compare;
          compareEl.style.display = '';
        } else if (compareEl) {
          compareEl.style.display = 'none';
        }

        /* Hero image */
        if (heroImg && imageSrc) {
          heroImg.removeAttribute('srcset');
          heroImg.src = imageSrc;
        }

        /* Add to cart button */
        if (addBtn) {
          addBtn.setAttribute('data-variant-id', id);
          if (available) {
            addBtn.disabled = false;
            addBtn.textContent = addBtn.classList.contains('product-page__add-btn--preorder') ? addBtn.textContent : 'Add to cart';
          } else {
            addBtn.disabled = true;
            addBtn.textContent = 'Sold Out';
          }
        }

        /* Sync sticky bar */
        var stickyBtn = document.querySelector('[data-sticky-add]');
        var stickyPrice = document.querySelector('[data-sticky-price]');
        if (stickyBtn) {
          stickyBtn.setAttribute('data-variant-id', id);
          if (available) {
            stickyBtn.disabled = false;
            stickyBtn.textContent = stickyBtn.classList.contains('sticky-atc__button--preorder') ? stickyBtn.textContent : 'Add to cart';
          } else {
            stickyBtn.disabled = true;
            stickyBtn.textContent = 'Sold Out';
          }
        }
        if (stickyPrice) stickyPrice.textContent = price;

        /* Update URL */
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        history.replaceState(null, '', url.toString());
      });
    });

    /* Quantity +/- */
    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
    }

    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }

    /* AJAX add to cart */
    if (addBtn) {
      addBtn.addEventListener('click', function() {
        var variantId = this.getAttribute('data-variant-id');
        var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
        if (!variantId || this.disabled) return;

        var button = this;
        var originalText = button.textContent;
        button.disabled = true;
        button.textContent = '...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
        })
        .then(function(res) {
          if (!res.ok) return res.json().then(function(err) { throw err; });
          return res.json();
        })
        .then(function(data) {
          button.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="display:inline;vertical-align:middle;margin-right:4px"><path d="M3 8.5L6.5 12L13 4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Added';
          button.style.backgroundColor = '#38a169';
          button.style.color = '#fff';
          setTimeout(function() {
            button.innerHTML = originalText;
            button.style.backgroundColor = '';
            button.style.color = '';
            button.disabled = false;
          }, 2000);

          var titleEl = page.querySelector('.product-page__title');
          var imgEl = page.querySelector('.product-page__hero-image');
          var pEl = page.querySelector('[data-product-price]');
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: {
            title: titleEl ? titleEl.textContent.trim() : '',
            image: imgEl ? imgEl.src : '',
            price: pEl ? pEl.textContent.trim() : ''
          }}));

          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var countEl = document.querySelector('.header__cart-count');
              if (countEl) {
                countEl.textContent = cart.item_count;
              } else {
                var cartLink = document.querySelector('.header__cart');
                if (cartLink) {
                  var span = document.createElement('span');
                  span.className = 'header__cart-count';
                  span.textContent = cart.item_count;
                  cartLink.appendChild(span);
                }
              }
            });
        })
        .catch(function(err) {
          var errMsg = (err && (err.description || err.message)) || '';
          var isStock = errMsg.toLowerCase().indexOf('stock') > -1 ||
                        errMsg.toLowerCase().indexOf('cart') > -1 ||
                        errMsg.toLowerCase().indexOf('quantity') > -1 ||
                        errMsg.toLowerCase().indexOf('available') > -1;
          var msg = isStock ? 'All items are in your cart' : errMsg || 'All items are in your cart';
          button.textContent = msg;
          button.style.backgroundColor = isStock ? '#d69e2e' : '#e53e3e';
          button.style.color = '#fff';
          setTimeout(function() {
            button.textContent = originalText;
            button.style.backgroundColor = '';
            button.style.color = '';
            button.disabled = false;
          }, 2500);
        });
      });
    }

    /* Sticky add to cart bar */
    var stickyBar = document.querySelector('[data-sticky-atc]');
    var stickyAddBtn = document.querySelector('[data-sticky-add]');

    if (stickyBar && addBtn) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('sticky-atc--visible');
          } else {
            stickyBar.classList.add('sticky-atc--visible');
          }
        });
      }, { threshold: 0 });

      observer.observe(addBtn);
    }

    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function() {
        var variantId = this.getAttribute('data-variant-id');
        var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
        if (!variantId || this.disabled) return;

        var button = this;
        var originalText = button.textContent;
        button.disabled = true;
        button.textContent = '...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
        })
        .then(function(res) {
          if (!res.ok) return res.json().then(function(err) { throw err; });
          return res.json();
        })
        .then(function(data) {
          button.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="display:inline;vertical-align:middle;margin-right:4px"><path d="M3 8.5L6.5 12L13 4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Added';
          button.style.backgroundColor = '#38a169';
          setTimeout(function() {
            button.innerHTML = originalText;
            button.style.backgroundColor = '';
            button.disabled = false;
          }, 2000);

          var titleEl = page.querySelector('.product-page__title');
          var imgEl = page.querySelector('.product-page__hero-image');
          var pEl = page.querySelector('[data-product-price]');
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: {
            title: titleEl ? titleEl.textContent.trim() : '',
            image: imgEl ? imgEl.src : '',
            price: pEl ? pEl.textContent.trim() : ''
          }}));

          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var countEl = document.querySelector('.header__cart-count');
              if (countEl) countEl.textContent = cart.item_count;
            });
        })
        .catch(function(err) {
          var errMsg = (err && (err.description || err.message)) || '';
          var isStock = errMsg.toLowerCase().indexOf('stock') > -1 ||
                        errMsg.toLowerCase().indexOf('cart') > -1 ||
                        errMsg.toLowerCase().indexOf('quantity') > -1 ||
                        errMsg.toLowerCase().indexOf('available') > -1;
          var msg = isStock ? 'All items are in your cart' : errMsg || 'All items are in your cart';
          button.textContent = msg;
          button.style.backgroundColor = isStock ? '#d69e2e' : '#e53e3e';
          setTimeout(function() {
            button.textContent = originalText;
            button.style.backgroundColor = '';
            button.disabled = false;
          }, 2500);
        });
      });
    }
    /* Condition guide modal */
    var conditionModal = document.querySelector('[data-condition-modal]');
    if (conditionModal) {
      document.querySelectorAll('[data-condition-guide-toggle]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          conditionModal.hidden = false;
          document.body.style.overflow = 'hidden';
        });
      });
      conditionModal.querySelectorAll('[data-condition-modal-close]').forEach(function(el) {
        el.addEventListener('click', function() {
          conditionModal.hidden = true;
          document.body.style.overflow = '';
        });
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && !conditionModal.hidden) {
          conditionModal.hidden = true;
          document.body.style.overflow = '';
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var STORAGE_KEY = 'kings_recently_viewed';
    var MAX_STORED = 20;

    function getRecentlyViewed() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch(e) {
        return [];
      }
    }

    function saveRecentlyViewed(list) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch(e) {}
    }

    /* Track current product page */
    var productMeta = document.querySelector('[data-recommended-products]');
    var currentProductId = productMeta ? productMeta.getAttribute('data-product-id') : null;

    if (currentProductId && currentProductId !== '' && currentProductId !== 'null') {
      var viewed = getRecentlyViewed();
      viewed = viewed.filter(function(id) { return id !== currentProductId; });
      viewed.unshift(currentProductId);
      if (viewed.length > MAX_STORED) viewed = viewed.slice(0, MAX_STORED);
      saveRecentlyViewed(viewed);
    }

    /* Load recommendations */
    document.querySelectorAll('[data-recommended-products]').forEach(function(section) {
      var productId = section.getAttribute('data-product-id');
      var limit = parseInt(section.getAttribute('data-limit'), 10) || 10;
      var sectionId = section.getAttribute('data-section-id');
      var track = section.querySelector('[data-row-track]');

      if (!track) return;

      /* If already rendered by Liquid (product page with recommendations), skip */
      if (track.children.length > 0) return;

      /* On non-product pages, load recently viewed products */
      var viewed = getRecentlyViewed();
      if (viewed.length === 0) {
        section.closest('.collection-row-wrapper').style.display = 'none';
        return;
      }

      var handles = viewed.slice(0, limit);
      var fetches = handles.map(function(id) {
        return fetch('/products/' + id + '.js')
          .then(function(r) {
            if (!r.ok) throw new Error(r.status);
            return r.json();
          })
          .catch(function() { return null; });
      });

      /* Try section rendering API for proper product cards */
      if (productId && productId !== '' && productId !== 'null') {
        fetch('/recommendations/products?product_id=' + productId + '&limit=' + limit + '&section_id=' + sectionId)
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newTrack = doc.querySelector('[data-row-track]');
            if (newTrack && newTrack.children.length > 0) {
              track.innerHTML = newTrack.innerHTML;
              initSlider(section);
            }
          })
          .catch(function() {});
      } else {
        /* Load recently viewed as cards via section rendering */
        var productUrls = handles.map(function(id) { return id; });
        loadRecentlyViewedCards(track, productUrls, section);
      }
    });

    function loadRecentlyViewedCards(track, productIds, section) {
      var loaded = 0;
      var total = productIds.length;
      var fragments = [];

      productIds.forEach(function(productId, index) {
        fetch('/products/' + productId + '?section_id=product-card-render')
          .then(function(r) {
            if (!r.ok) throw new Error();
            return r.text();
          })
          .then(function(html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var card = doc.querySelector('.product-card');
            if (card) {
              fragments[index] = card.outerHTML;
            }
          })
          .catch(function() {})
          .finally(function() {
            loaded++;
            if (loaded >= total) {
              fragments.forEach(function(cardHtml) {
                if (!cardHtml) return;
                var item = document.createElement('div');
                item.className = 'collection-row__item';
                item.innerHTML = cardHtml;
                track.appendChild(item);
              });
              if (track.children.length === 0) {
                section.closest('.collection-row-wrapper').style.display = 'none';
              }
              initSlider(section);
            }
          });
      });
    }

    function initSlider(row) {
      var slider = row.querySelector('[data-row-slider]');
      var track = row.querySelector('[data-row-track]');
      var prevBtn = row.querySelector('[data-row-prev]');
      var nextBtn = row.querySelector('[data-row-next]');

      if (!slider || !track || !prevBtn || !nextBtn) return;

      var position = 0;

      function getItemsPerView() {
        var w = window.innerWidth;
        if (w >= 1400) return 6;
        if (w >= 1200) return 5;
        if (w >= 990) return 5;
        if (w >= 850) return 4;
        if (w >= 550) return 3;
        return 2;
      }

      function getItemWidth() {
        var item = track.querySelector('.collection-row__item');
        if (!item) return 0;
        var style = getComputedStyle(track);
        var gap = parseFloat(style.gap) || 16;
        return item.offsetWidth + gap;
      }

      function totalItems() {
        return track.querySelectorAll('.collection-row__item').length;
      }

      function maxPosition() {
        return Math.max(0, totalItems() - getItemsPerView());
      }

      function updateButtons() {
        prevBtn.disabled = position <= 0;
        nextBtn.disabled = position >= maxPosition();
      }

      function slide() {
        var itemWidth = getItemWidth();
        track.style.transform = 'translateX(-' + (position * itemWidth) + 'px)';
        updateButtons();
      }

      prevBtn.addEventListener('click', function() {
        position = Math.max(0, position - getItemsPerView());
        slide();
      });

      nextBtn.addEventListener('click', function() {
        position = Math.min(maxPosition(), position + getItemsPerView());
        slide();
      });

      updateButtons();
    }

    /* Also track recently viewed via product handle for non-product pages */
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      var handle = window.ShopifyAnalytics.meta.product.id.toString();
      var viewed = getRecentlyViewed();
      if (viewed.indexOf(handle) === -1) {
        viewed.unshift(handle);
        if (viewed.length > MAX_STORED) viewed = viewed.slice(0, MAX_STORED);
        saveRecentlyViewed(viewed);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function() {
    var section = document.querySelector('.search-page[data-collection-section]');
    if (!section) return;

    /* Sort by */
    var sortSelect = section.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    /* View toggle */
    var gridView = section.querySelector('[data-view-target="grid"]');
    var listView = section.querySelector('[data-view-target="list"]');

    if (gridView && listView) {
      section.querySelectorAll('[data-view]').forEach(function(button) {
        button.addEventListener('click', function() {
          var view = this.getAttribute('data-view');

          section.querySelectorAll('[data-view]').forEach(function(b) {
            b.classList.remove('collection__view-button--active');
            b.setAttribute('aria-pressed', 'false');
          });
          this.classList.add('collection__view-button--active');
          this.setAttribute('aria-pressed', 'true');

          gridView.hidden = view === 'list';
          listView.hidden = view === 'grid';
        });
      });
    }

    /* Load more */
    var productGrid = section.querySelector('[data-product-grid]');
    var productList = section.querySelector('[data-product-list]');
    var wrapper = section.querySelector('[data-load-more-wrapper]');
    var btn = section.querySelector('[data-load-more]');
    var countEl = section.querySelector('[data-load-more-count]');
    var total = wrapper ? parseInt(wrapper.getAttribute('data-total-products'), 10) : 0;
    var nextUrl = wrapper ? wrapper.getAttribute('data-next-url') : '';

    if (!btn || !productGrid) return;

    function loaded() {
      return productGrid.querySelectorAll('.collection__item').length;
    }

    function refreshUI() {
      if (countEl) {
        countEl.textContent = loaded() + ' of ' + total + ' results';
      }
      if (btn) {
        btn.hidden = !nextUrl;
        btn.disabled = false;
        var text = btn.querySelector('[data-load-more-text]');
        var spinner = btn.querySelector('[data-load-more-spinner]');
        if (text) text.hidden = false;
        if (spinner) spinner.hidden = true;
      }
    }

    btn.addEventListener('click', function() {
      if (!nextUrl) return;
      btn.disabled = true;
      var text = btn.querySelector('[data-load-more-text]');
      var spinner = btn.querySelector('[data-load-more-spinner]');
      if (text) text.hidden = true;
      if (spinner) spinner.hidden = false;

      fetch(nextUrl)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          doc.querySelectorAll('[data-product-grid] .collection__item').forEach(function(el) {
            productGrid.appendChild(el);
          });

          if (productList) {
            doc.querySelectorAll('[data-product-list] .collection__list-item').forEach(function(el) {
              productList.appendChild(el);
            });
          }

          var fetchedWrapper = doc.querySelector('[data-load-more-wrapper]');
          nextUrl = fetchedWrapper ? fetchedWrapper.getAttribute('data-next-url') : '';
          refreshUI();
        })
        .catch(function() {
          refreshUI();
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["series-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-series-gallery]').forEach(function(gallery) {
      var slider = gallery.querySelector('[data-series-slider]');
      var prevBtn = gallery.querySelector('[data-series-prev]');
      var nextBtn = gallery.querySelector('[data-series-next]');
      if (!slider) return;

      function updateArrows() {
        var atStart = slider.scrollLeft <= 1;
        var atEnd = slider.scrollLeft + slider.offsetWidth >= slider.scrollWidth - 1;
        if (prevBtn) prevBtn.disabled = atStart;
        if (nextBtn) nextBtn.disabled = atEnd;
      }

      function smoothScroll(amount) {
        slider.scrollTo({ left: slider.scrollLeft + amount, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function() {
        smoothScroll(-slider.offsetWidth * 0.6);
      });
      if (nextBtn) nextBtn.addEventListener('click', function() {
        smoothScroll(slider.offsetWidth * 0.6);
      });

      slider.addEventListener('scroll', updateArrows);

      var active = gallery.querySelector('.series-thumb--active');
      if (active) {
        var offset = active.offsetLeft - (slider.offsetWidth / 2) + (active.offsetWidth / 2);
        slider.scrollLeft = Math.max(0, offset);
      }

      updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["series-index"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var CACHE_KEY = 'kings-series-index-v3';
    var VIEW_KEY = 'kings-series-index-view';
    var CACHE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

    var section = document.querySelector('[data-series-section]');
    if (!section) return;

    var list = section.querySelector('[data-series-list]');
    var grid = section.querySelector('[data-series-grid]');
    var wrapper = section.querySelector('[data-load-more-wrapper]');
    var statusText = section.querySelector('[data-status-text]');
    var statusSpinner = section.querySelector('[data-status-spinner]');
    var noMatchesEl = section.querySelector('[data-series-no-matches]');
    var searchInput = section.querySelector('[data-filter-search]');
    var brandList = section.querySelector('[data-brand-list]');
    var brandEmpty = section.querySelector('[data-brand-empty]');
    var decadeList = section.querySelector('[data-decade-list]');
    var clearBtn = section.querySelector('[data-filter-clear]');
    if (!list || !grid || !wrapper) return;

    var totalPages = parseInt(wrapper.getAttribute('data-total-pages'), 10) || 1;
    var currentPage = parseInt(wrapper.getAttribute('data-current-page'), 10) || 1;
    var nextUrlBase = wrapper.getAttribute('data-next-url') || '';

    function getHandle(el) {
      return el.getAttribute('data-series-handle') || el.getAttribute('data-series-title') || '';
    }

    function getCurrentHandles() {
      var ids = [];
      list.querySelectorAll('.scl').forEach(function(el) { ids.push(getHandle(el)); });
      return ids;
    }

    function readCache() {
      try {
        var raw = localStorage.getItem(CACHE_KEY);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data || !data.listHtml || !data.gridHtml || data.v !== 3) return null;
        if (Date.now() - data.timestamp > CACHE_TTL_MS) return null;
        return data;
      } catch (e) { return null; }
    }

    function writeCache() {
      try {
        var listHtml = '';
        var gridHtml = '';
        var ids = [];
        list.querySelectorAll('.scl').forEach(function(el) {
          listHtml += el.outerHTML;
          ids.push(getHandle(el));
        });
        grid.querySelectorAll('.scg').forEach(function(el) {
          gridHtml += el.outerHTML;
        });
        localStorage.setItem(CACHE_KEY, JSON.stringify({
          v: 3,
          timestamp: Date.now(),
          listHtml: listHtml,
          gridHtml: gridHtml,
          ids: ids
        }));
      } catch (e) { /* localStorage full or disabled */ }
    }

    /* Replace server's page-1 render with cache if we have it */
    var cache = readCache();
    var hasServerFirstPage = true;
    if (cache) {
      list.innerHTML = cache.listHtml;
      grid.innerHTML = cache.gridHtml;
      hasServerFirstPage = false;
    }

    var totalLoaded = list.querySelectorAll('.scl').length;
    var pendingPages = Math.max(0, totalPages - (hasServerFirstPage ? currentPage : 0));

    function setStatus(msg, loading) {
      if (statusText) statusText.textContent = msg;
      if (statusSpinner) statusSpinner.hidden = !loading;
    }

    function getCheckedValues(root, selector) {
      var checked = [];
      if (!root) return checked;
      root.querySelectorAll(selector + ':checked').forEach(function(cb) {
        checked.push(cb.value);
      });
      return checked;
    }

    function rebuildBrandOptions() {
      if (!brandList) return;
      var checkedBrands = getCheckedValues(brandList, 'input[data-filter-brand]');
      var counts = Object.create(null);
      list.querySelectorAll('.scl').forEach(function(el) {
        var b = el.getAttribute('data-series-brand');
        if (!b) return;
        counts[b] = (counts[b] || 0) + 1;
      });

      var brands = Object.keys(counts).sort(function(a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });

      if (brandEmpty) brandEmpty.hidden = brands.length > 0;

      var existing = {};
      brandList.querySelectorAll('input[data-filter-brand]').forEach(function(cb) {
        existing[cb.value] = cb.closest('li');
      });

      brands.forEach(function(b) {
        var li = existing[b];
        if (!li) {
          li = document.createElement('li');
          li.className = 'series-filters__item';
          li.innerHTML =
            '<label class="series-filters__checkbox-label">' +
              '<input type="checkbox" class="series-filters__checkbox" data-filter-brand>' +
              '<span class="series-filters__checkbox-custom"></span>' +
              '<span class="series-filters__checkbox-text"></span>' +
              '<span class="series-filters__count"></span>' +
            '</label>';
          var cb = li.querySelector('input');
          cb.value = b;
          cb.addEventListener('change', applyFilters);
          li.querySelector('.series-filters__checkbox-text').textContent = b;
          brandList.appendChild(li);
        }
        li.querySelector('.series-filters__count').textContent = counts[b];
      });

      checkedBrands.forEach(function(b) {
        var cb = brandList.querySelector('input[data-filter-brand][value="' + cssEscape(b) + '"]');
        if (cb) cb.checked = true;
      });
    }

    function rebuildDecadeCounts() {
      if (!decadeList) return;
      var counts = Object.create(null);
      list.querySelectorAll('.scl').forEach(function(el) {
        var startStr = el.getAttribute('data-series-start') || '';
        var start = parseInt(startStr, 10);
        if (isNaN(start)) return;
        var decade = Math.floor(start / 10) * 10;
        counts[decade] = (counts[decade] || 0) + 1;
      });
      decadeList.querySelectorAll('[data-decade-count]').forEach(function(el) {
        var d = el.getAttribute('data-decade-count');
        var c = counts[d] || 0;
        el.textContent = c;
        var cb = el.parentElement.querySelector('input[data-filter-decade]');
        if (cb) cb.disabled = c === 0;
      });
    }

    function cssEscape(v) {
      return String(v).replace(/(["\\])/g, '\\$1');
    }

    function matchesByHandle(handle, q, brands, decades, item) {
      var title = item.getAttribute('data-series-title') || '';
      var brand = item.getAttribute('data-series-brand') || '';
      var startStr = item.getAttribute('data-series-start') || '';
      var start = parseInt(startStr, 10);

      if (q && title.indexOf(q) === -1) return false;
      if (brands.length && brands.indexOf(brand) === -1) return false;
      if (decades.length) {
        if (isNaN(start)) return false;
        var seriesDecade = Math.floor(start / 10) * 10;
        if (decades.indexOf(seriesDecade) === -1) return false;
      }
      return true;
    }

    function applyFilters() {
      var q = searchInput ? searchInput.value.trim().toLowerCase() : '';
      var brands = getCheckedValues(brandList, 'input[data-filter-brand]');
      var decades = getCheckedValues(decadeList, 'input[data-filter-decade]').map(function(d) {
        return parseInt(d, 10);
      });
      var hasFilter = !!(q || brands.length || decades.length);

      var visible = 0;

      list.querySelectorAll('.scl').forEach(function(el) {
        var match = matchesByHandle(getHandle(el), q, brands, decades, el);
        el.hidden = !match;
        if (match) visible++;
      });

      grid.querySelectorAll('.scg').forEach(function(el) {
        var match = matchesByHandle(getHandle(el), q, brands, decades, el);
        el.hidden = !match;
      });

      if (clearBtn) clearBtn.hidden = !hasFilter;
      if (noMatchesEl) noMatchesEl.hidden = visible > 0;

      var msg = visible + ' of ' + totalLoaded + ' series';
      if (pendingPages > 0) msg = visible + ' shown · loading more…';
      setStatus(msg, pendingPages > 0);
    }

    function buildPageUrl(pageNum) {
      if (nextUrlBase) {
        return nextUrlBase.replace(/([?&])page=\d+/, '$1page=' + pageNum);
      }
      return window.location.pathname + '?page=' + pageNum;
    }

    function fetchPage(pageNum) {
      return fetch(buildPageUrl(pageNum))
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fetchedList = doc.querySelector('[data-series-list]');
          var fetchedGrid = doc.querySelector('[data-series-grid]');
          var listItems = [];
          var gridItems = [];
          if (fetchedList) {
            fetchedList.querySelectorAll('.scl').forEach(function(el) { listItems.push(el); });
          }
          if (fetchedGrid) {
            fetchedGrid.querySelectorAll('.scg').forEach(function(el) { gridItems.push(el); });
          }
          return { page: pageNum, listItems: listItems, gridItems: gridItems };
        })
        .catch(function() {
          return { page: pageNum, listItems: [], gridItems: [], error: true };
        });
    }

    function prefetchAllPages() {
      var startPage = hasServerFirstPage ? currentPage + 1 : 1;
      var pageNums = [];
      for (var i = startPage; i <= totalPages; i++) {
        pageNums.push(i);
      }

      if (pageNums.length === 0) {
        pendingPages = 0;
        rebuildBrandOptions();
        rebuildDecadeCounts();
        applyFilters();
        writeCache();
        return;
      }

      var loadingLabel = cache ? ' shown · refreshing…' : ' shown · loading more…';
      setStatus(totalLoaded + loadingLabel, true);

      Promise.all(pageNums.map(fetchPage)).then(function(results) {
        results.sort(function(a, b) { return a.page - b.page; });

        if (hasServerFirstPage) {
          /* Cache miss path — append fetched pages after server's page 1 */
          results.forEach(function(r) {
            r.listItems.forEach(function(el) {
              list.appendChild(el);
              totalLoaded++;
            });
            r.gridItems.forEach(function(el) {
              grid.appendChild(el);
            });
          });
        } else {
          /* Cache hit path — build canonical fresh lists, swap only if different */
          var freshListItems = [];
          var freshGridItems = [];
          results.forEach(function(r) {
            r.listItems.forEach(function(el) { freshListItems.push(el); });
            r.gridItems.forEach(function(el) { freshGridItems.push(el); });
          });
          var freshIds = freshListItems.map(getHandle);
          var currentIds = getCurrentHandles();

          if (freshIds.join('|') !== currentIds.join('|')) {
            list.innerHTML = '';
            grid.innerHTML = '';
            freshListItems.forEach(function(el) { list.appendChild(el); });
            freshGridItems.forEach(function(el) { grid.appendChild(el); });
            totalLoaded = freshListItems.length;
          }
        }

        pendingPages = 0;
        rebuildBrandOptions();
        rebuildDecadeCounts();
        applyFilters();
        writeCache();
      }).catch(function() {
        pendingPages = 0;
        applyFilters();
      });
    }

    function setView(view) {
      var isList = view === 'list';
      grid.hidden = isList;
      list.hidden = !isList;
      section.querySelectorAll('[data-view]').forEach(function(btn) {
        var active = btn.getAttribute('data-view') === view;
        btn.classList.toggle('series-index__view-button--active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      try { localStorage.setItem(VIEW_KEY, view); } catch (e) {}
    }

    var savedView = 'grid';
    try { savedView = localStorage.getItem(VIEW_KEY) || 'grid'; } catch (e) {}
    if (savedView === 'list') setView('list');

    section.querySelectorAll('[data-view]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        setView(this.getAttribute('data-view'));
      });
    });

    if (searchInput) searchInput.addEventListener('input', applyFilters);
    if (decadeList) {
      decadeList.querySelectorAll('input[data-filter-decade]').forEach(function(cb) {
        cb.addEventListener('change', applyFilters);
      });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        if (searchInput) searchInput.value = '';
        section.querySelectorAll('input[data-filter-brand], input[data-filter-decade]').forEach(function(cb) {
          cb.checked = false;
        });
        applyFilters();
      });
    }

    rebuildBrandOptions();
    rebuildDecadeCounts();
    applyFilters();
    prefetchAllPages();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var slideshow = document.querySelector('[data-slideshow]');
    if (!slideshow) return;

    var track = slideshow.querySelector('[data-slideshow-track]');
    var slides = slideshow.querySelectorAll('[data-slideshow-slide]');
    var dots = slideshow.querySelectorAll('[data-slideshow-dot]');
    var prevBtn = slideshow.querySelector('[data-slideshow-prev]');
    var nextBtn = slideshow.querySelector('[data-slideshow-next]');
    var current = 0;
    var total = slides.length;
    var autoplayInterval = null;
    var autoplayDelay = (parseInt(slideshow.getAttribute('data-slideshow-speed'), 10) || 5) * 1000;

    if (total <= 1) return;

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;

      track.style.transform = 'translateX(-' + (current * 100) + '%)';

      slides.forEach(function(s, i) {
        s.classList.toggle('slideshow__slide--active', i === current);
      });

      dots.forEach(function(d, i) {
        d.classList.toggle('slideshow__dot--active', i === current);
      });
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      stopAutoplay();
      autoplayInterval = setInterval(next, autoplayDelay);
    }

    function stopAutoplay() {
      if (autoplayInterval) clearInterval(autoplayInterval);
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { next(); startAutoplay(); });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var index = parseInt(this.getAttribute('data-slideshow-dot'), 10);
        goTo(index);
        startAutoplay();
      });
    });

    /* Touch swipe */
    var startX = 0;
    var isDragging = false;

    slideshow.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      isDragging = true;
      stopAutoplay();
    }, { passive: true });

    slideshow.addEventListener('touchend', function(e) {
      if (!isDragging) return;
      isDragging = false;
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) next(); else prev();
      }
      startAutoplay();
    });

    /* Pause on hover */
    slideshow.addEventListener('mouseenter', stopAutoplay);
    slideshow.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  })();

  } catch(e) { console.error(e); }
})();
})();
